import * as React from "react";

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.81 53.81" {...props}>
    <defs>
      <style>{".cls-1{fill:#fff}"}</style>
    </defs>
    <path fill="#e6e7e7" d="M7.99 36.52 26.91 8.14l18.92 28.38H7.99z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.36}
      d="M45.83 36.52 26.91 8.14 7.99 36.52h37.84z"
    />
    <path
      className="cls-1"
      d="M26.91 32.59a1.48 1.48 0 0 1-1.05-.43 1.44 1.44 0 0 1-.44-1 1.48 1.48 0 0 1 2.58-1.1 1.49 1.49 0 0 1 .44 1.05 1.5 1.5 0 0 1-1.49 1.48zm-.41-4.52a.5.5 0 0 1-.5-.46c-.15-1.79-.33-3.65-.55-5.53s-.33-3.07-.33-3.43a1.88 1.88 0 0 1 .5-1.31 1.79 1.79 0 0 1 2.58 0 1.88 1.88 0 0 1 .49 1.31c0 .36-.11 1.48-.33 3.43s-.42 3.75-.58 5.54a.51.51 0 0 1-.5.45z"
    />
    <path
      d="M26.91 17.29a1.2 1.2 0 0 1 .92.39 1.37 1.37 0 0 1 .36 1c0 .33-.11 1.46-.33 3.37s-.41 3.76-.58 5.55h-.78q-.22-2.71-.5-5.6c-.22-1.91-.33-3-.33-3.37a1.4 1.4 0 0 1 .36-1 1.21 1.21 0 0 1 .93-.39m0 12.83a1 1 0 0 1 .69 1.68.94.94 0 0 1-.69.29 1 1 0 0 1-.7-.29 1 1 0 0 1 0-1.38 1 1 0 0 1 .7-.3m0-13.83a2.19 2.19 0 0 0-1.66.72 2.37 2.37 0 0 0-.63 1.64c0 .24 0 .86.34 3.48.21 1.9.39 3.76.54 5.52a1 1 0 0 0 1 .92h.78a1 1 0 0 0 1-.91c.17-1.77.37-3.63.58-5.53.31-2.62.34-3.24.34-3.48a2.37 2.37 0 0 0-.69-1.6 2.21 2.21 0 0 0-1.65-.71zm0 12.83a2 2 0 0 0-1.41.59 2 2 0 0 0-.58 1.4 1.93 1.93 0 0 0 .59 1.41 2 2 0 0 0 1.4.57 2 2 0 0 0 1.39-.57 1.94 1.94 0 0 0 .6-1.41 2 2 0 0 0-2-2z"
      fill="currentColor"
    />
  </svg>
);

export default SvgComponent;
